export default __webpack_public_path__ + "static/media/Round_Guide.f91b45c3.svg";